import { render, staticRenderFns } from "./RefundTransactionNoteDialog.vue?vue&type=template&id=235fd22e&"
import script from "./RefundTransactionNoteDialog.vue?vue&type=script&lang=js&"
export * from "./RefundTransactionNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports